import { render, staticRenderFns } from "./ButtonClosedTicket.vue?vue&type=template&id=93393316&"
import script from "./ButtonClosedTicket.vue?vue&type=script&lang=ts&"
export * from "./ButtonClosedTicket.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports